import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetGeoWishToCandidateResponse extends BackendResponse {}
export interface SetGeoWishToCandidateParameters extends NextApiParams {
  municipalityIds: number[];
  countyIds: number[];
}

export const setGeoWishToCandidate = withNextApi<
  SetGeoWishToCandidateResponse,
  SetGeoWishToCandidateParameters
>("/cvp/CvpSetGeoWishToCandidate");
